import { render, staticRenderFns } from "./ManagerComments.vue?vue&type=template&id=5f1e0786&scoped=true"
import script from "./ManagerComments.vue?vue&type=script&lang=js"
export * from "./ManagerComments.vue?vue&type=script&lang=js"
import style0 from "./ManagerComments.vue?vue&type=style&index=0&id=5f1e0786&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1e0786",
  null
  
)

export default component.exports